<div class="container-fluid" >
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Carga masiva | Usuarios | Institucionales</h3>
        </div>
    </div>
  </div>
  <hr class="text-dark mb-3">
  <form [formGroup]="formulario" id="formulario">

    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Información del formato</h5>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <label class="form-label">Centro <span class="text-danger">*</span></label>
          <select class="form-control" id='id_centro' formControlName="centro">
            <option *ngFor="let a of centro;" value="{{a.id_centro}}">{{a.nombre}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Estado <span class="text-danger">*</span></label>
          <select class="form-control" id='grado_instruccion' formControlName="estado">
            <option *ngFor="let a of estado;" value="{{a.id_estado}}">{{a.nombre}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Gerencias <span class="text-danger">*</span></label>
          <select class="form-control" id='id_gerencia' formControlName="gerencias">
            <option *ngFor="let a of gerencias;" value="{{a.id_gerencia}}">{{a.nombre}}</option>
          </select>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <label class="form-label">Ambito <span class="text-danger">*</span></label>
          <select class="form-control" id='id_ambito' formControlName="ambito">
            <option *ngFor="let a of ambito;" value="{{a.id_ambito}}">{{a.nombre}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Rol <span class="text-danger">*</span></label>
          <select class="form-control" id='id_rol' formControlName="rol" (change)="valida($event.target)">
            <option *ngFor="let a of rol;" value="{{a.id_rol}}">{{a.nombre}}</option>
          </select>
        </div>
        <div class="col-md-4" [style.display]="this.validaTipoRol ? 'block' : 'none'">
          <label class="form-label">Tipo formador <span class="text-danger">*</span></label>
          <select class="form-control" id='id_sexo' formControlName="tipo_formador">
            <option *ngFor="let a of tipo_formador;" value="{{a.id_tipo_formador}}">{{a.nombre}}</option>
          </select>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-12 text-center">
          <button type="button" class="btn btn-lg btn-primary" (click)="descargar_formato()">Descarga Formato</button>
        </div>
      </div>
    </div>


  </form>


</div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
